<!--
  - Copyright (c) 2022 by 安徽网才信息技术股份有限公司
  -
  - 除非事先获得版权所有人的许可, 禁止以下几项行为:
  - 1. 对该软件的任何源代码和技术文档进行任意形式的打包、分发或复制用于其他目的。
  - 2. 向第三方透露任何与该软件相关的源代码或技术文档。
  - 3. 更改或删除软件或源码中的版权声明。
  -
  -->

<template>
    <div class="m-foot" :class="className">
        <div v-if="$config.ycAgents.includes($store.state.agent)">
            <p class="text">
                皖ICP备12018891号-3
            </p>
        </div>
        <div v-else>
            <div class="link">
                <a v-for="(item, index) in $store.state.meta.friendLink" :key="index" :href="item.url" target="_blank">
                    {{ item.name }}
                </a>
            </div>
            <p class="text" style="white-space: pre-line;">
                {{ $store.state.meta.footerInfo }}
            </p>
            <p class="text">
                <a href="https://beian.miit.gov.cn/" style="color: #97A3B7;">皖ICP备12018891号-3</a>
            </p>
        </div>
    </div>
</template>

<script>
import {getMeta} from '@/api/common';

export default {
    name: 'LayoutFooter',
    props: {
        className: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            time: '2023'
        };
    },
    created() {
        this.getMeta();
        const nowDate = new Date();
        this.time = nowDate.getFullYear();
    },
    methods: {
        async getMeta() {
            const { data } = await getMeta();
            document.title = data.title ? data.title : '人事考试网';
            this.$store.commit('setMeta', data);
        }
    }
};
</script>

<style scoped>

</style>
